/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="97.4"
        height="95.59"
        viewBox="0 0 97.4 95.59"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M60.24 48.5h6v-5h-6Zm6.15 20h3.22v3.42h-11.9v-3.47h3.22V55.52h-3.22V52h8.68Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M89.24 33.42H38.07a8.18 8.18 0 0 0-8.15 8.15v32.5a8.11 8.11 0 0 0 8.14 7.9h35.57l13.14 13.24.09.09a1.26 1.26 0 0 0 2-1V82h.32a8.18 8.18 0 0 0 8.16-8.16V41.57a8.18 8.18 0 0 0-8.1-8.15Zm-51.17 2.5h51.17a5.68 5.68 0 0 1 5.66 5.65v32.24a5.68 5.68 0 0 1-5.66 5.66H87.5a1.26 1.26 0 0 0-1.12 1.25V91.3L75.01 79.84a1.26 1.26 0 0 0-.89-.37H38.07a5.61 5.61 0 0 1-5.65-5.66V41.57a5.68 5.68 0 0 1 5.65-5.65Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M57.02 0a7.92 7.92 0 0 1 7.89 7.64v27h-2.5V7.89a5.42 5.42 0 0 0-5.17-5.39H7.89A5.42 5.42 0 0 0 2.5 7.67v31.22a5.42 5.42 0 0 0 5.17 5.39H9.4a1.26 1.26 0 0 1 1.25 1.12v10.19L21.5 44.65a1.24 1.24 0 0 1 .74-.36h9.08v2.5h-8.4L10.29 59.51a1.25 1.25 0 0 1-2.13-.76v-12H7.9a7.91 7.91 0 0 1-7.89-7.64V7.89A7.92 7.92 0 0 1 7.64 0h49.38Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M20.43 19.75a3.65 3.65 0 0 1 0 7.29 3.58 3.58 0 0 1-3.65-3.65 3.63 3.63 0 0 1 3.65-3.64M28.81 23.39a3.65 3.65 0 1 0 3.69-3.64 3.63 3.63 0 0 0-3.64 3.64M40.84 23.39a3.65 3.65 0 1 0 3.66-3.64 3.63 3.63 0 0 0-3.64 3.64"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'TwoInformationalWordBubblesIcon';

export default Icon;
